import axios from 'axios';
import { Typography, Box } from '@mui/material';
import config from '../config';
import DataLoader from '../components/common/DataLoader';

const TestLogin = () => {
  const fetchFunction = (jwtToken, onData, onError, onFinally) => {
    axios.get(`${config.apiBaseUrl}/v1/test401`)
      .then((response) => {
        onData(response);
      })
      .catch((err) => {
        onError(err, 'cargar datos');
      })
    .finally(() => onFinally());
  };

  return (
    <DataLoader fetchFunction={fetchFunction}>
      {(data) => {
        return (
          <Box>
            <Typography variant="h5">Test 401 Login</Typography>
            {data}
          </Box>
      );
      }}
    </DataLoader>
  );
};

export default TestLogin;
